<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('seller.addInvitationCode')"
    :visible.sync="newCodeDialog"
    custom-class="drawerClass"
    direction="ltr"
    size="520px"
    @close="handleNewCodeDialog"
  >
    <div style="padding: 0 20px">
      <el-form
        ref="addFormRef"
        :inline="false"
        :model="addForm"
        :rules="rules"
        class="search-form"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('navbar.siteName')" prop="siteId" style="width: 100%">
              <el-select
                v-model="addForm.siteId"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 账号名称 -->
            <el-form-item
              :label="$t('customerManagements.AccountName')"
              prop="userName"
              style="width: 100%"
            >
              <el-input
                v-model.trim="addForm.userName"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
                maxlength="50"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--派送车辆类型-->
            <el-form-item
              :label="$t('receivablePayable.deliveryVehicleType')"
              prop="deliveryVehicleType"
            >
              <el-select
                v-model="addForm.deliveryVehicleType"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in deliveryVehicleTypeList"
                  :key="item.dictId"
                  :label="item.dictDescribe"
                  :value="item.dictName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 派送价格 -->
            <el-form-item
              :label="$t('seller.deliveryPrice')"
              prop="deliveryPrice"
              style="width: 100%"
            >
              <el-input
                v-model="addForm.deliveryPrice"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style="float: right">
              <!--确定-->
              <el-button
                size="small" type="primary" @click="submitForm"
              >{{ $t('GlobalSetObj.determine') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { deliveryRegistergenerateCode } from '@/api/newExpressAPI/userModule';
import { checkFee, checkOnlyNumberEN } from '@/utils/validate';

export default {
  props: {
    deliveryVehicleTypeList: {
      type: Array,
      default: () => []
    },
    siteList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newCodeDialog: false,
      timeValue: [],
      addForm: {
        siteId: '', // 网点id
        userName: '', // 账号名称
        deliveryVehicleType: '', // 派送车辆类型(看需求)
        deliveryPrice: '' // 派送价格
      },
      rules: {
        siteId: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        userName: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: checkOnlyNumberEN,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ],
        deliveryVehicleType: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        deliveryPrice: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: checkFee,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    submitForm() {
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          deliveryRegistergenerateCode(this.addForm).then((res) => {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.handleNewCodeDialog();
            this.$emit('invoke-search');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 控制弹框
    openCodeDialog() {
      this.newCodeDialog = true;
    },
    handleNewCodeDialog() {
      this.$refs['addFormRef'].resetFields();
      this.newCodeDialog = false;
    }
  }
};
</script>

<style scoped></style>
